var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container recognition", class: { mobile: _vm.mobile } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "/site_media/version-4bcbc6ac77/images/company/testimonials/testimonials-review-stars-2x.gif"
        }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("Over 50,000 "),
      _c("span", [_vm._v("5-star")]),
      _vm._v(" reviews on iOS App Store and Google Play")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }